import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, Button, IconButton } from 'material-ui';
import { DialogActions, DialogContent, DialogContentText, DialogTitle } from 'material-ui/Dialog';
import CloseIcon from 'material-ui-icons/Close';
import Slide from 'material-ui/transitions/Slide';
import Dictionary from '../../model/Dictionary';

function Transition (props) {
  return <Slide direction='up' {...props} />;
}

const NotificationErrorDialog = ({ notification, defaultTitle, open, handleClose, classes }) => (
  <Dialog
    disableBackdropClick
    disableEscapeKeyDown
    open={open}
    onClose={handleClose}
    transition={Transition}
    classes={classes}
  >
    <div className='notification-header'>
      <div className='title'>
        <DialogTitle className='title-error'>{notification.title || defaultTitle}</DialogTitle>
      </div>
      <div className='close'>
        <IconButton color='inherit' onClick={handleClose} aria-label='Close'>
          <CloseIcon />
        </IconButton>
      </div>
    </div>
    <DialogContent>
      <DialogContentText>{notification.description}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={handleClose}
        color='primary'
        variant='raised'
        className='notification-error-close'
      >
        {Dictionary.notifications.close}
      </Button>
    </DialogActions>
  </Dialog>
);

NotificationErrorDialog.propTypes = {
  notification: PropTypes.object,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  defaultTitle: PropTypes.string,
  classes: PropTypes.object,
};

export default NotificationErrorDialog;



// WEBPACK FOOTER //
// ./src/components/notifications/NotificationErrorDialog.js